<template>
	<div class="file-list">
		<file-download :warning="(request.analysis || request.snapshot) && !request.hasRequestFile" :enabled="request.analysis || request.snapshot" label="Request" :id="request.rootTrackingNumber" :type="fileTypes.Request"></file-download>
		<file-download :enabled="request.hasResponseFile" label="Response" :id="request.rootTrackingNumber" :type="fileTypes.Response"></file-download>
		<file-download :enabled="request.hasPkgFiles" label="Pkgs" :id="request.rootTrackingNumber" :type="fileTypes.Pkgs"></file-download>
		<file-download :enabled="request.hasErrorFiles" label="Errors" :id="request.rootTrackingNumber" :type="fileTypes.Errors"></file-download>
		<file-download :enabled="request.hasAnyFiles" label="All Files" :id="request.rootTrackingNumber" :type="fileTypes.All"></file-download>
	</div>
</template>

<script>
import FileDownload from "../file-download.vue";
import { fileTypes } from "../../enums";

export default {
	props: ["request"],
	components: {
		FileDownload,
	},
	data() {
		return {
			fileTypes,
		};
	},
};
</script>
<style scoped>
	.file-list > span {
		display: inline-block;
		margin: 4px 10px 4px 0;
	}
</style>
